// base
import { useState } from 'react';

// library
import { Button, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';

// style
import styled from 'styled-components';
import { themeOptions } from 'styles';

const StyledFloatMenu = styled.div`
  position: absolute;
  right: -15px;

  .MuiButtonBase-root {
    color: ${themeOptions.palette.green.main} !important;
  }
  .MuiTouchRipple-root {
    width: 100%;
  }
`;

export const FloatMenu = ({ onModify, onDelete }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const floatOpen = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleModify = () => {
    handleClose();
    onModify();
  };

  const handleDelete = () => {
    handleClose();
    onDelete();
  };
  return (
    <StyledFloatMenu className="flatMenu">
      <Button
        id="basic-button"
        aria-controls={floatOpen ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={floatOpen ? 'true' : undefined}
        onClick={handleClick}
      >
        <MoreVertIcon />
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={floatOpen}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
      >
        {/* <MenuItem onClick={handleModify}>Modify</MenuItem> */}
        <MenuItem onClick={handleDelete}>Delete</MenuItem>
      </Menu>
    </StyledFloatMenu>
  );
};
